import React, { useContext, useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.css";
import "./NavbarStyles.scss"; // Custom CSS file for Navbar
import { Link, useNavigate } from "react-router-dom";
import { routes } from "../../routes/RoutesComponent";
import { Collapse, Navbar, Nav, NavItem, NavLink } from "reactstrap";
import UserContext from "../../../../domain/providers/user/UserContext";
import UserContextType from "../../../../domain/providers/user/UserContextType";
import di from "../../../../di/DependencyInjection";
import SignOutUseCase, { SignOutUseCaseName } from "../../../../domain/use_cases/auth/SignOutUseCase";
import TypeVehicleContext from "../../../../domain/providers/typeVehicle/TypeVehicleContext";
import TypeVehicleContextType from "../../../../domain/providers/typeVehicle/TypeVehicleContextType";
import AccountCircleIcon from "../../assets/AccountCircleIcon";
import { IoIosArrowDown } from "react-icons/io";
import LogoutIcon from "../../assets/LogoutIcon";
import Icons from "../../assets/Icons";
import { GoogleAuthButton } from "../googleAuthButton";
import HostApi from "../../../../data/settings/HostApi";
import { API_URL } from "../../../../config/env";

const NavbarComponent = () => {
    const [isExpired, setIsExpired] = useState(false);

    const { user, setUser, clearUser } = useContext(UserContext) as UserContextType;
    const { typeVehicles } = useContext(TypeVehicleContext) as TypeVehicleContextType;
    const [isOpen, setIsOpen] = useState(false);
    const [hasCars, setHasCars] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        if (!user?.name) {
            setHasCars(false);
            return;
        }
        fetch(`${API_URL}/get-cars-user/`, {
            headers: { "Content-Type": "application/json", Authorization: "Bearer " + HostApi.getToken() },
        })
            .then((res) => res.json())
            .then((cars) => setHasCars(Array.isArray(cars) && cars.length > 0))
            .catch(() => setHasCars(false));
    }, [user?.name]);

    const [timeLeft, setTimeLeft] = useState({
        days: "0",
        hours: "0",
        minutes: "0",
        seconds: "0",
    });

    const toggleNavbar = () => {
        setIsOpen(!isOpen);
    };
    const _handleAccountButton = async () => {
        if (user?.name) {
            navigate(routes.detailUser.relativePath);
        } else {
            navigate(routes.signIn.relativePath);
        }
    };

    const _handleAccountLogout = async () => {
        if (user == null) {
            navigate(routes.signIn.relativePath);
        } else {
            await di.get<SignOutUseCase>(SignOutUseCaseName).call();
            clearUser();
            navigate(routes.signIn.relativePath);
        }
    };

    // useEffect(() => {
    //     const isShowed = window.localStorage.getItem("orangeFestModal");
    //     if (isShowed) {
    //         setIsShowed(true);
    //     }
    //     if (isShowed) return;
    //     window.localStorage.setItem("orangeFestModal", "true");
    // }, []);

    const [lastScrollY, setLastScrollY] = useState(0);
    const [isVisible, setIsVisible] = useState(true);

    useEffect(() => {
        const handleScroll = () => {
            const currentScrollY = window.scrollY;
            if (currentScrollY > lastScrollY) {
                setIsVisible(false); // Ocultar navbar cuando hace scroll hacia abajo
            } else {
                setIsVisible(true); // Mostrar navbar cuando hace scroll hacia arriba
            }

            setLastScrollY(currentScrollY);
        };

        window.addEventListener("scroll", handleScroll);

        return () => window.removeEventListener("scroll", handleScroll);
    }, [window.scrollY]);

    useEffect(() => {
        const interval = setInterval(() => {
            const now = new Date();
            const target = new Date("02/24/2025");
            const difference = target.getTime() - now.getTime();

            if (difference <= 0) {
                clearInterval(interval);
                setTimeLeft({ days: "00", hours: "00", minutes: "00", seconds: "00" });
                setIsExpired(true); // Oculta la sección cuando el tiempo expira
                return;
            }

            const days = Math.floor(difference / (1000 * 60 * 60 * 24));
            const hours = Math.floor((difference / (1000 * 60 * 60)) % 24);
            const minutes = Math.floor((difference / (1000 * 60)) % 60);
            const seconds = Math.floor((difference / 1000) % 60);

            setTimeLeft({
                days: String(days).padStart(2, "0") + ":",
                hours: String(hours).padStart(2, "0") + ":",
                minutes: String(minutes).padStart(2, "0") + ":",
                seconds: String(seconds).padStart(2, "0"),
            });
        }, 1000);

        return () => clearInterval(interval);
    }, []);

    return (
        <>
            <Navbar className="bg-transparent px-3 w-100 z-2" expand="lg">
                <Link className="navbar-brand me-5" to={routes.home.relativePath}>
                    <img src="/assets/logos/horizontal.svg" title="wcar" alt="wcar" height="50" loading="lazy" />
                </Link>

                <Collapse navbar id="navbarNav" isOpen={isOpen}>
                    <Nav className="ml-auto d-md-flex align-items-center" navbar>
                        <NavItem className="mx-3">
                            <div className="dropdown">
                                <div className="dropdown-title">
                                    <Link
                                        to={routes.aboutUs.relativePath}
                                        className="nav-link d-flex align-items-center"
                                        style={{ fontWeight: 500 }}
                                    >
                                        Sobre Nosotros
                                        <span className="ms-1">
                                            <IoIosArrowDown size={18} />
                                        </span>
                                    </Link>
                                </div>
                                <div className="dropdown_content" style={{ zIndex: 99999999 }}>
                                    <Link to={routes.aboutUs.relativePath} className="dropdown-item">
                                        Nuestra empresa
                                    </Link>
                                    <Link to={routes.headquarter.relativePath} className="dropdown-item">
                                        Nuestras sedes
                                    </Link>
                                </div>
                            </div>
                        </NavItem>

                        <NavItem className="mx-3">
                            <div className="dropdown">
                                <div className="dropdown-title d-flex align-items-center">
                                    <Link
                                        to={routes.buyOrSell.relativePath}
                                        style={{ fontWeight: 500 }}
                                        className="nav-link d-flex align-items-center"
                                    >
                                        Compra o Vende
                                        <span className="text_reduced ms-1">
                                            <IoIosArrowDown size={18} />
                                        </span>
                                    </Link>
                                </div>
                                <div className="dropdown_content" style={{ zIndex: 999999999 }}>
                                    <div className="dropdown">
                                        <div className="dropdown-title d-flex align-items-center">
                                            <Link
                                                to={routes.buyYourCar.relativePath}
                                                className="nav-link d-flex align-items-center"
                                            >
                                                Compra tu carro
                                                <span className="ms-1">
                                                    <IoIosArrowDown size={18} />
                                                </span>
                                            </Link>
                                        </div>
                                        <div className="dropdown_content right" style={{ zIndex: 999999999 }}>
                                            {typeVehicles.map((typeVehicle, index) => (
                                                <Link
                                                    key={index}
                                                    to={
                                                        parseInt(typeVehicle.id) === 2
                                                            ? "/compra-tu-carro/camionetas-usadas" +
                                                              "?type_vehicle=" +
                                                              typeVehicle.name
                                                            : parseInt(typeVehicle.id) === 3
                                                              ? "/compra-tu-carro/carros-sedan-usados" +
                                                                "?type_vehicle=" +
                                                                typeVehicle.name
                                                              : parseInt(typeVehicle.id) === 4
                                                                ? "/compra-tu-carro/carros-híbridos-colombia" +
                                                                  "?type_vehicle=" +
                                                                  typeVehicle.name
                                                                : parseInt(typeVehicle.id) === 6
                                                                  ? "/compra-tu-carro/hatchback-colombia" +
                                                                    "?type_vehicle=" +
                                                                    typeVehicle.name
                                                                  : parseInt(typeVehicle.id) === 12
                                                                    ? "/compra-tu-carro/carros-coupe" +
                                                                      "?type_vehicle=" +
                                                                      typeVehicle.name
                                                                    : parseInt(typeVehicle.id) === 13
                                                                      ? "/compra-tu-carro/carros-pickup" +
                                                                        "?type_vehicle=" +
                                                                        typeVehicle.name
                                                                      : parseInt(typeVehicle.id) === 14
                                                                        ? "/compra-tu-carro/carros-devortivos" +
                                                                          "?type_vehicle=" +
                                                                          typeVehicle.name
                                                                        : parseInt(typeVehicle.id) === 18
                                                                          ? "/compra-tu-carro/motocicleta" +
                                                                            "?type_vehicle=" +
                                                                            typeVehicle.name
                                                                          : parseInt(typeVehicle.id) === 8
                                                                            ? "/compra-tu-carro/camionetas-usadas" +
                                                                              "?type_vehicle=" +
                                                                              typeVehicle.name
                                                                            : routes.buyYourCar.relativePath +
                                                                              "?type_vehicle=" +
                                                                              typeVehicle.name
                                                    }
                                                    className="dropdown-item"
                                                >
                                                    <img
                                                        src={typeVehicle.photo}
                                                        alt={typeVehicle.name}
                                                        title={typeVehicle.name}
                                                        className="me-2"
                                                        width={24}
                                                        loading="lazy"
                                                        decoding="async"
                                                    />
                                                    {typeVehicle.name}
                                                    <span className="text_gray">({typeVehicle.count ?? 0})</span>
                                                </Link>
                                            ))}
                                        </div>
                                    </div>
                                    <Link to={routes.buyYourMotorcycle.relativePath} className="nav-link">
                                        Compra tu moto
                                    </Link>
                                    <Link to={routes.buyYourTruck.relativePath} className="nav-link">
                                        Compra tu camión
                                    </Link>
                                    <Link to={routes.sellYourCar.relativePath} className="nav-link">
                                        Vende tu carro
                                    </Link>
                                    <Link to={routes.buyYourVan.relativePath} className="nav-link">
                                        Compra tu van
                                    </Link>
                                </div>
                            </div>
                        </NavItem>
                        <NavItem className="mx-3">
                            <div className="dropdown">
                                <div className="dropdown-title">
                                    <div className="nav-link d-flex align-items-center" style={{ fontWeight: 500 }}>
                                        Servicios
                                        <span className="ms-1">
                                            <IoIosArrowDown size={18} />
                                        </span>
                                    </div>
                                </div>
                                <div className="dropdown_content" style={{ zIndex: 99999999 }}>
                                    <Link to={routes.services.relativePath} className="dropdown-item">
                                        Financiación
                                    </Link>
                                    <Link to={"https://wcarseguros.com/"} className="dropdown-item">
                                        Seguros
                                    </Link>
                                    <Link to={routes.procedures.relativePath} className="dropdown-item">
                                        Trámites
                                    </Link>
                                    <Link to={routes.workshopAndService.relativePath} className="dropdown-item">
                                        Taller
                                    </Link>
                                </div>
                            </div>
                        </NavItem>
                        <NavItem className="mx-3">
                            <Link className="nav-link" to={routes.blog.relativePath} style={{ fontWeight: 500 }}>
                                Blog
                            </Link>
                        </NavItem>
                        <NavItem className="mx-3">
                            <NavLink href={routes.contact.relativePath} style={{ fontWeight: 500 }}>
                                Contacto
                            </NavLink>
                        </NavItem>
                        {user?.name && hasCars && (
                            <NavItem className="mx-3">
                                <NavLink href={routes.detailedCarUser.relativePath} style={{ fontWeight: 500 }}>
                                    Tus Vehículos
                                </NavLink>
                            </NavItem>
                        )}
                    </Nav>
                </Collapse>

                <div className="d-flex navbar_icons">
                    {user?.name ? <div /> : <GoogleAuthButton />}

                    {user?.name && (
                        <Link
                            to={routes.favorites.relativePath}
                            className="d-flex align-items-center btn"
                            aria-label="Mis favoritos"
                            title="Mis favoritos"
                        >
                            <svg width="33" height="33" viewBox="0 0 33 33" fill="none">
                                <path
                                    d="M16.5 27C16.5 27 5 19.5 5 11.8C5 8.6 7.4 6.5 10.2 6.5C12.9 6.5 15.2 8.2 16.5 10.4C17.8 8.2 20.1 6.5 22.8 6.5C25.6 6.5 28 8.6 28 11.8C28 19.5 16.5 27 16.5 27Z"
                                    stroke="#1E1E1E"
                                    strokeWidth="1.5"
                                    strokeLinejoin="round"
                                />
                                <circle cx="26" cy="9" r="4.5" fill="#F23B4B" />
                            </svg>
                        </Link>
                    )}

                    <div
                        className={`btn d-flex align-items-center btn-account ${
                            window.location.pathname == "/thankyou" && "transition"
                        }`}
                        onClick={_handleAccountButton}
                    >
                        <AccountCircleIcon size={33} />

                        <div className="d-none d-xl-block" style={{ marginLeft: "10px" }}>
                            {user?.name ?? "Iniciar sesión"}
                        </div>
                    </div>
                    {user?.name && (
                        <div
                            onClick={_handleAccountLogout}
                            className="d-flex btn btn-cyan"
                            style={{ marginTop: 8, cursor: "pointer" }}
                        >
                            <LogoutIcon />
                        </div>
                    )}

                    <button
                        className="navbar-toggler border-0"
                        type="button"
                        data-toggle="collapse"
                        data-target="#navbarNav"
                        aria-controls="navbarNav"
                        aria-expanded="false"
                        aria-label="Toggle navigation"
                        onClick={toggleNavbar}
                    >
                        <span className="navbar-toggler-icon"></span>
                    </button>
                </div>
            </Navbar>
        </>
    );
};

export default NavbarComponent;
